import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '../../assets/icons/download-cloud-02.svg';
import Button from '../../components/Button/Button';
import CustomSelectWithFilter from '../Common/CustomSelect/CustomSelectWithFilter';
import { exportExcel } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import CustomTable from '../Common/CustomTable/CustomTable';
import CustomPagination from '../Common/CustomPagination/CustomPagination';
import { getCustomerGroupList, getProjectWiseCustomerGroupListing } from '../../redux/dashboardSlice/dashboardSlice';
import { PATHNAME } from '../../pathname';
import SearchBar from '../Common/SearchBar/SearchBar';
import { DatePicker } from "antd";
import dayjs from "dayjs";

const getCurrentFYRange = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;

        const fyStartYear = currentMonth >= 4 ? currentYear : currentYear - 1;

        return [
                dayjs(`${fyStartYear}-04-01`),
                dayjs(`${fyStartYear + 1}-03-01`)
        ];
};

const defaultRange = getCurrentFYRange();

const { RangePicker } = DatePicker;

const ProjectCustomerGroupWise = () => {
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const [currentPage, setCurrentPage] = useState(1);
        const [customerGroupFilter, setCustomerGroupFilter] = useState(null);
        const pageSize = 10; // Items per page
        const [searchValue, setSearchValue] = useState('');
        const [showAdditionalColumns, setShowAdditionalColumns] = useState(false);

        const [sortBy, setSortBy] = useState("REVENUE");
        const [sortOrder, setSortOrder] = useState("DESC");
        const [dateRange, setDateRange] = useState(defaultRange);

        const sortByOptions = [
                { label: "Revenue", value: "REVENUE" },
                { label: "Project Cost", value: "PROJECT_COST" },
                { label: "DM %", value: "DM_PERCENT" },
                { label: "Cash Inflow", value: "CASH_INFLOW" },
                { label: "Cash Outflow", value: "CASH_OUTFLOW" },
                { label: "Profit/Loss", value: "PROFIT_LOSS" },
        ];

        const sortOrderOptions = [
                { label: "Ascending", value: "ASC" },
                { label: "Descending", value: "DESC" },
        ];

        const { projectWiseCustomerGroup, customerGroupList, projectWiseCustomerGroupTotal, projectWiseCustomerGroupLoading } = useSelector((state) => state.dashboard);
        const additionalColumns = [
                {
                        title: 'INTERNAL ORDER NO.',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        align: 'center',
                        fixed: 'left',
                        width: 250,
                        render: (text) => (
                                <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-200 text-sm font-medium text-right">
                                        {text}
                                </span>
                        ),
                },
                {
                        title: 'CUSTOMER GROUP',
                        dataIndex: 'CUSTOMER_GROUP_NAME',
                        key: 'CUSTOMER_GROUP_NAME',
                        align: 'center',
                        width: 250,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
                {
                        title: 'CUSTOMER NAME',
                        dataIndex: 'CUST_NAME',
                        key: 'CUST_NAME',
                        align: 'center',
                        width: 250,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
        ];
        const customerGroupColumns = [
                {
                        title: 'PROJECTS',
                        dataIndex: 'PROJ_NAME',
                        key: 'PROJ_NAME',
                        width: 200,
                        align: 'center',
                        fixed: 'left',
                        render: (text, record) => {
                                const url = `${PATHNAME.ADMIN_ACTIVE_PROJECT_DETAILS}/${encodeURIComponent(
                                        record.PROJ_NAME,
                                )}?ioNo=${record.IO_NO}&revNo=${record.REV_NO}`;

                                return (
                                        <a
                                                onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate(url);
                                                }}
                                                href={url}
                                                className="text-blue-500 underline cursor-pointer text-right"
                                        >
                                                {text || '--'}
                                        </a>
                                );
                        },
                },

                ...(showAdditionalColumns ? additionalColumns : []),

                {
                        title: 'REVENUE',
                        dataIndex: 'revenue',
                        key: 'revenue',
                        width: 150,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
                {
                        title: 'PROJECT COST',
                        dataIndex: 'projectCost',
                        key: 'projectCost',
                        width: 180,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
                {
                        title: 'PROFIT/LOSS',
                        dataIndex: 'profit_loss',
                        key: 'profit_loss',
                        width: 180,
                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'DM%',
                        dataIndex: 'DM',
                        key: 'DM',
                        width: 150,
                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'CASH INFLOW',
                        dataIndex: 'totalCashInflow',
                        key: 'totalCashInflow',
                        width: 180,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
                {
                        title: 'CASH OUTFLOW',
                        dataIndex: 'totalCashOutflow',
                        key: 'totalCashOutflow',
                        width: 180,
                        render: (text) => <div className="text-right">{text ?? '--'}</div>,
                },
        ];
        // useEffect(() => {
        //         dispatch(
        //                 getProjectWiseCustomerGroupListing({
        //                         page: currentPage,
        //                         limit: pageSize,
        //                         customerGroupCode: customerGroupFilter,
        //                         search: searchValue,
        //                 }),
        //         );
        // }, [currentPage, searchValue]);

        useEffect(() => {
                dispatch(
                        getProjectWiseCustomerGroupListing({
                                page: currentPage,
                                limit: pageSize,
                                customerGroupCode: customerGroupFilter,
                                search: searchValue,
                                sort_by: sortBy,
                                sort_to: sortOrder,

                                from_year: dateRange?.[0]?.format("YYYY"),
                                from_month: dateRange?.[0]?.format("MM"),

                                to_year: dateRange?.[1]?.format("YYYY"),
                                to_month: dateRange?.[1]?.format("MM"),
                        })
                );
        }, [
                currentPage,
                searchValue,
                customerGroupFilter,
                sortBy,
                sortOrder,
                dateRange,
        ]);

        useEffect(() => {
                dispatch(getCustomerGroupList());
        }, []);

        const selectedCustomerGroup = customerGroupList?.find(
                (item) => item.CUSTOMER_GROUP_CODE === customerGroupFilter
        )?.CUSTOMER_GROUP_NAME;

        return (
                <div>
                        {/* <div className=" flex flex-col gap-6 pt-8"> */}
                        {/* <div className="font-inter font-semibold text-[16px] leading-[150%] tracking-[0%] text-[#101828]">Project Report - Customer Group Wise</div>
                        <div className="flex flex-row justify-between">
                                <div>
                                        <SearchBar
                                                onSearch={setSearchValue}
                                                className="!w-[230px]"
                                        />


                                </div>
                                <RangePicker
                                        format="MMMM YYYY"
                                        picker="month"
                                        value={dateRange}
                                        onChange={(value) => {
                                                setDateRange(value);
                                                setCurrentPage(1);
                                        }}
                                />

                                <div
                                        className={`h-[40px] px-4 rounded-lg flex items-center gap-3 transition-all duration-200 border cursor-pointer
    ${showAdditionalColumns
                                                        ? "border-[#1570EF] bg-[#EFF8FF]"
                                                        : "border-[#D0D5DD] bg-white"
                                                }`}
                                        onClick={() => setShowAdditionalColumns(!showAdditionalColumns)}
                                >
                                        <span
                                                className={`text-sm font-medium whitespace-nowrap
        ${showAdditionalColumns
                                                                ? "text-[#1570EF]"
                                                                : "text-[#344054]"
                                                        }`}
                                        >
                                                Show Additional Columns
                                        </span>

                                        <button
                                                type="button"
                                                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors
        ${showAdditionalColumns
                                                                ? "bg-[#1570EF]"
                                                                : "bg-[#D0D5DD]"
                                                        }`}
                                        >
                                                <span
                                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
            ${showAdditionalColumns
                                                                        ? "translate-x-4"
                                                                        : "translate-x-0.5"
                                                                }`}
                                                />
                                        </button>
                                </div>
                                <CustomSelectWithFilter
                                        data={sortByOptions}
                                        value={sortBy}
                                        onChange={setSortBy}
                                        placeholder="Sort By"
                                        className="w-[180px]"
                                />

                                <CustomSelectWithFilter
                                        data={sortOrderOptions}
                                        value={sortOrder}
                                        allowClear={false}
                                        onChange={setSortOrder}
                                        placeholder="Sort Order"
                                        className="w-[180px]"
                                />

                                <CustomSelectWithFilter
                                        showSearch="true"
                                        data={
                                                Array.isArray(customerGroupList)
                                                        ? customerGroupList.map((value) => ({
                                                                label: value?.CUSTOMER_GROUP_NAME,
                                                                value: value?.CUSTOMER_GROUP_CODE,
                                                        }))
                                                        : []
                                        }
                                        onChange={(value) => {
                                                setCurrentPage(1);
                                                setCustomerGroupFilter(value);
                                                dispatch(
                                                        getProjectWiseCustomerGroupListing({
                                                                page: 1,
                                                                limit: pageSize,
                                                                customerGroupCode: value, // single value
                                                        }),
                                                );
                                        }}
                                        placeholder="All Customer Groups"
                                        className="w-[15rem]"
                                />
                                <Button
                                                        text="Export report"
                                                        icon={DownloadIcon}
                                                        onClick={() =>
                                                                dispatch(
                                                                        exportExcel({
                                                                                key: 'project_report_customer_group_wise',
                                                                        }),
                                                                )
                                                        }
                                                />
                        </div> */}
                        {/* </div> */}

                        <div className="flex flex-col gap-6 pt-8">
                                <div className="font-inter font-semibold text-[16px] leading-[150%] tracking-[0%] text-[#101828]">
                                        Project Report - Customer Group Wise
                                </div>

                                <div className="w-fit inline-flex items-center bg-white border border-[#D0D5DD] rounded-lg px-3 py-2 text-sm font-medium text-[#475467]">
                                        {customerGroupFilter && selectedCustomerGroup
                                                ? `Total Projects of ${selectedCustomerGroup} :`
                                                : "Total Projects:"}
                                        &nbsp;
                                        <span className="text-[#1570EF] font-semibold">
                                                {projectWiseCustomerGroupTotal ?? 0}
                                        </span>
                                </div>

                                {/* Filter Bar */}

                                <div className="flex flex-wrap items-start justify-start gap-4 p-4 bg-[#F9FAFB] border border-[#EAECF0] rounded-xl ">
                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Search by Project Name
                                                </span>
                                                <SearchBar
                                                        onSearch={setSearchValue}
                                                        className="!w-[280px] "
                                                />
                                        </div>
                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Financial Year Range
                                                </span>
                                                <RangePicker
                                                        format="MMMM YYYY"
                                                        picker="month"
                                                        value={dateRange}
                                                        className="!h-[40px]"
                                                        placeholder={['From Month', 'To Month']}
                                                        onChange={(value) => {
                                                                setDateRange(value);
                                                                setCurrentPage(1);
                                                        }}
                                                />
                                        </div>

                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Sort Metric
                                                </span>
                                                <CustomSelectWithFilter
                                                        data={sortByOptions}
                                                        value={sortBy}
                                                        onChange={setSortBy}
                                                        placeholder="Sort By"
                                                        className="w-[220px]"
                                                />
                                        </div>

                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Sort Order
                                                </span>
                                                <CustomSelectWithFilter
                                                        data={sortOrderOptions}
                                                        value={sortOrder}
                                                        allowClear={false}
                                                        onChange={setSortOrder}
                                                        placeholder="Sort Order"
                                                        className="w-[180px]"
                                                />
                                        </div>

                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Filter by Customer Group
                                                </span>
                                                <CustomSelectWithFilter
                                                        showSearch="true"
                                                        data={
                                                                Array.isArray(customerGroupList)
                                                                        ? customerGroupList.map((value) => ({
                                                                                label: value?.CUSTOMER_GROUP_NAME,
                                                                                value: value?.CUSTOMER_GROUP_CODE,
                                                                        }))
                                                                        : []
                                                        }
                                                        value={customerGroupFilter}
                                                        onChange={(value) => {
                                                                setCurrentPage(1);
                                                                setCustomerGroupFilter(value);
                                                        }}
                                                        placeholder="All Customer Groups"
                                                        className="w-[280px]"
                                                />
                                        </div>

                                        <div className="flex flex-col gap-1">
                                                <span className="text-xs font-medium text-[#667085]">
                                                        Additional Columns
                                                </span>

                                                <div
                                                        className={`h-[40px] !w-[120px] px-4 rounded-lg flex items-center gap-3 border cursor-pointer transition-all duration-200
                ${showAdditionalColumns
                                                                        ? 'border-[#1570EF] bg-[#EFF8FF]'
                                                                        : 'border-[#D0D5DD] bg-white'
                                                                }`}
                                                        onClick={() => setShowAdditionalColumns(!showAdditionalColumns)}
                                                >
                                                        <span
                                                                className={`text-sm font-medium whitespace-nowrap
                    ${showAdditionalColumns
                                                                                ? 'text-[#1570EF]'
                                                                                : 'text-[#344054]'
                                                                        }`}
                                                        >
                                                                View
                                                        </span>

                                                        <button
                                                                type="button"
                                                                className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors
                    ${showAdditionalColumns
                                                                                ? 'bg-[#1570EF]'
                                                                                : 'bg-[#D0D5DD]'
                                                                        }`}
                                                        >
                                                                <span
                                                                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                        ${showAdditionalColumns
                                                                                        ? 'translate-x-6'
                                                                                        : 'translate-x-0.5'
                                                                                }`}
                                                                />
                                                        </button>
                                                </div>
                                        </div>

                                </div>
                        </div>
                        <div className="flex flex-col gap-6 pt-8">
                                <CustomTable
                                        dataSource={projectWiseCustomerGroup}
                                        columns={customerGroupColumns}
                                        loading={projectWiseCustomerGroupLoading}
                                />
                                <div>
                                        <CustomPagination
                                                totalItems={projectWiseCustomerGroupTotal}
                                                pageSize={pageSize}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                        />
                                </div>
                        </div>
                </div>
        );
};

export default ProjectCustomerGroupWise;
